import React from 'react';
import './info.css'
import Typography from "@mui/material/Typography";

const scrollDown = () => {
    const seccionDestino = document.getElementById('info-container');

    if (seccionDestino) {
        const { top } = seccionDestino.getBoundingClientRect();
        window.scrollTo({
            top: window.scrollY + top - 67,
            behavior: 'smooth',
        });
    }
};


const Info = () => {
    return (
        <div className="info">
            <div className="left-info">

                <div className="left-info-text">
                    <Typography
                        sx={{
                            color: '#ff6c00',
                            fontFamily: 'Inter, sans-serif',
                            fontSize: '15px',
                            '@media (max-width: 1070px)': {
                                fontSize: '14px',
                            },
                            fontWeight: '600',
                            textTransform: 'uppercase',
                            letterSpacing: '3px',
                            marginBottom: '5px'
                        }}
                    >
                        Aseguramos tu tranquilidad
                    </Typography>
                    <Typography
                        sx={{
                            color: '#3b3b3b',
                            fontFamily: 'Inter, sans-serif',
                            fontSize: '43px',
                            '@media (max-width: 1070px)': {
                                fontSize: '35px',
                            },
                            fontWeight: '700',
                            marginBottom: '25px'
                        }}
                    >
                        Conoce nuestro amplio portafolio en el mundo
                        de los seguros
                    </Typography>
                    <Typography
                        sx={{
                            color: '#656565',
                            fontFamily: 'Inter, sans-serif',
                            fontSize: '16px',
                            '@media (max-width: 1070px)': {
                                fontSize: '15px',
                            },
                            fontWeight: '400',
                            marginBottom: '35px',
                            paddingRight: '40px',
                            lineHeight: '1.8em'
                        }}
                    >
                        Con una trayectoria sólida y un compromiso inquebrantable, nos enorgullece ofrecer un extenso portafolio de productos diseñado para proteger lo que más valoras.
                    </Typography>

                    <div className="icons-inf">
                        <img src='/Assets/icons/apreton-de-manos.png' alt='info' style={{ height: '55px', marginRight: '20px' }}/>
                        <div className="icon-inf">
                            <Typography
                                sx={{
                                    color: '#3b3b3b',
                                    fontFamily: 'Inter, sans-serif',
                                    fontSize: '20px',
                                    '@media (max-width: 1070px)': {
                                        fontSize: '19px',
                                        marginBottom: '10px',
                                    },
                                    fontWeight: '600',
                                    marginBottom: '17px',
                                    marginTop: '-5px'
                                }}
                            >
                                Mas que un seguro, un aliado
                            </Typography>
                            <Typography
                                sx={{
                                    color: '#656565',
                                    fontFamily: 'Heebo, sans-serif',
                                    fontSize: '16px',
                                    '@media (max-width: 1070px)': {
                                        fontSize: '15px',
                                    },
                                    fontWeight: '400',
                                }}
                            >
                                Elige la mejor opción para proteger tu patrimonio, tu familia y tu futuro.
                            </Typography>
                        </div>
                    </div>

                    <button onClick={scrollDown} className='us-button'>
                        <span>Conoce más</span>
                    </button>
                </div>
                
            </div>
            <div className="right-i">
                <div className="right-images">
                    <img className="left-image" src="/Assets/image-07.jpg" alt="Imagen Izquierda" />
                    <img className="right-image" src="/Assets/image-06.jpg" alt="Imagen Derecha" />
                </div>
            </div>
        </div>
    );
};

export default Info;
